<template>
  <div id="resumo-proposta">
    <v-row>
      <v-col cols="12" class="py-0 grey--text text--darken-3 font-weight-medium">
        <resumo-cliente-dados-gerais :model="model"></resumo-cliente-dados-gerais>
        <br/>

      </v-col>
    </v-row>
  </div>
</template>
<script>
export default {
  props: {
    modal: { type: Boolean, default: false },
    model: { type: Object }
  },
  data () {
    return {
      isLoaded: false,
    };
  },
  methods: {
    load (model) {
      this.$api.UTIL.Functions.SetAllButNull(this, this, 'model', model);
      this.isLoaded = true;
    },
  },
};
</script>

<style>
#resumo-proposta span.text-label {
  display: block;
  font-weight: 400;
}

#resumo-proposta span.text-h5 {
  font-weight: 400;
}

#resumo-proposta div.item-value {
  padding-bottom: 2px;
  padding-top: 2px;
  padding-left: 12px;
  padding-right: 12px;
  display: flex;
  justify-content: space-between;
}

#resumo-proposta span.text-value-label,
#resumo-proposta span.text-subtitle-1 {
  font-weight: 400;
}

#resumo-proposta span.text-value {
  text-align: end;
}
</style>
